import React from 'react';
import { EditIcon } from '../../../assets/icons';

export const ActionBoxBills = ({
  setPopUp,
  setPopUpData,
  type,
  vendor_cost_line_id,
  product,
  qty,
  unit_price,
}) => {
  return (
    <div className="td-num">
      {type === 'Container' || type === 'Threads' || type === 'Box and Polybag' ? (
        <EditIcon
          onClick={(e) => {
            e.stopPropagation();
            setPopUp(1);
            setPopUpData({ type, vendor_cost_line_id, product, qty, unit_price });
          }}
        />
      ) : (
        '-'
      )}
    </div>
  );
};
